// Animate on scroll
import AOS from 'aos';

(() => {
  const windowDelta = window.innerHeight / 5;
  AOS.init({
    duration: 700,
    once: true,
    anchorPlacement: 'top-bottom',
    offset: windowDelta,
  });

  window.addEventListener('load', () => {
    AOS.refresh();
  });
})();
